import { Theme } from '@mui/material/styles';
import merge from 'lodash/merge';

import { componentsOverrides } from '../../overrides';

import { alert } from './components/alert';
import { avatar } from './components/avatar';
import { button } from './components/button';
import { card } from './components/card';
import { chip } from './components/chip';
import { cssBaselineV2 } from './components/css-baseline';
import { drawerV2 } from './components/drawer';
import { iconButtonV2 } from './components/iconButton';
import { paper } from './components/paper';
import { progress } from './components/progress';
import { tabsV2 } from './components/tabs';
import { textFieldV2 } from './components/textfield';
import { toggleButton } from './components/toggleButton';
import { tooltipV2 } from './components/tooltip';

// ----------------------------------------------------------------------
// V2 Design System — Component overrides
// Strategy: start from v1 overrides, then deep-merge v2-specific changes.
// This ensures we inherit all existing component styling and only override
// what the new design system changes.
// ----------------------------------------------------------------------

export function componentsOverridesV2(theme: Theme) {
  // Get all v1 component overrides as baseline
  const v1Components = componentsOverrides(theme);

  // V2-specific overrides (only the components that differ from Figma tokens)
  const v2Overrides = merge(
    textFieldV2(theme),
    drawerV2(theme),
    button(theme),
    card(theme),
    chip(theme),
    progress(theme),
    alert(theme),
    avatar(theme),
    paper(theme),
    toggleButton(theme),
    cssBaselineV2(),
    tooltipV2(theme),
    tabsV2(theme),
    iconButtonV2(theme),
    // Future v2 component overrides will be added here:
    // checkboxV2(theme),
    // etc.
  );

  // Override MuiButton defaultProps: v1 sets color:'inherit', v2 needs color:'primary'
  if (v1Components.MuiButton) {
    v1Components.MuiButton.defaultProps = { ...v1Components.MuiButton.defaultProps, color: 'primary' };
  }

  // Deep merge: v2 overrides win over v1 where they overlap
  return merge(v1Components, v2Overrides);
}
